import { MONTH_NAME_RU_MAP } from '@/helpers/dateFns';
import { VIEW_TYPE_KEY } from '../../constants';

export const MONTHS = Object.entries(MONTH_NAME_RU_MAP).map(([key, value]) => ({ value: parseInt(key), text: value }));

export const VIEW_TYPE_MAP = {
  [VIEW_TYPE_KEY.months]: 'Месяцы',
  [VIEW_TYPE_KEY.weeks]: 'Недели',
  [VIEW_TYPE_KEY.days]: 'Дни',
};
export const VIEW_TYPES = Object.entries(VIEW_TYPE_MAP).map(([key, value]) => ({ value: key, text: value }));

export const TASK_COLOR = {
  withEvent: '#B3DBDB',
  withoutEvent: '#FFD3A4',
};

export const TASK_TONE = {
  withEvent: 'success',
  withoutEvent: 'primary',
};

export const LEGEND_VALUE_SIZE = 16;

export const TASK_TAG_KEY = {
  included: 'included',
  foreign: 'foreign',
};

export const TASK_TAGS = {
  [TASK_TAG_KEY.included]: {
    key: TASK_TAG_KEY.included,
    icon: '$iunion',
    text: 'Включено в план',
    visible: (announcement) => !!(announcement.othersActiveInclusionsRequests || []).length,
  },
  [TASK_TAG_KEY.foreign]: {
    key: TASK_TAG_KEY.foreign,
    icon: '$iuser-team',
    text: 'Сторонний план',
    visible: (announcement) => !announcement.isOwner,
  },
};
